import { uuid } from 'admin';
import { DocumentInfo, DocumentType } from 'api';
import { useFormContext } from 'form';
import { IconButton, List, ListItem, ListItemIcon, ListItemText, Typography } from 'ui';
import { Delete, Folder } from 'ui/icons';

import type { UploadDocumentProps } from '../../types';
import { DOCUMENT_TYPE_DISPLAYED_VALUE } from '../../utils/document';

type Documents = {
  documents?: UploadDocumentProps[];
};

type Props = {
  name: keyof Documents;
  uploadedDocuments: DocumentInfo[];
};

export const DocumentList = ({ name, uploadedDocuments }: Props) => {
  const { watch, setValue } = useFormContext<Documents>();
  const documents = watch(name);
  const removeDocument = (index: number) => {
    const updatedDocuments = documents?.filter((_, i) => i !== index);
    setValue(name, updatedDocuments);
  };

  if (!documents?.length && !uploadedDocuments.length) {
    return null;
  }

  return (
    <>
      {documents && documents.length > 0 ? (
        <>
          <Typography variant="h6">Documents to be added:</Typography>
          <List dense>
            {documents?.map((document, index: number) => (
              <ListItem
                alignItems="flex-start"
                key={uuid()}
                secondaryAction={
                  <IconButton aria-label="delete" onClick={() => removeDocument(index)}>
                    <Delete color="error" />
                  </IconButton>
                }
              >
                <ListItemIcon>
                  <Folder color="primary" />
                </ListItemIcon>
                <ListItemText primary={DOCUMENT_TYPE_DISPLAYED_VALUE[document.type]} secondary={document.file.name} />
              </ListItem>
            ))}
          </List>
        </>
      ) : null}
      {uploadedDocuments && uploadedDocuments.length > 0 ? (
        <>
          <Typography variant="h6">Added documents:</Typography>
          <List dense>
            {uploadedDocuments?.map((document) => (
              <ListItem alignItems="flex-start" key={document.id}>
                <ListItemIcon>
                  <Folder color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary={DOCUMENT_TYPE_DISPLAYED_VALUE[document.type as DocumentType]}
                  secondary={document.file_name}
                />
              </ListItem>
            ))}
          </List>
        </>
      ) : null}
    </>
  );
};
